import "@expert/theme/global.css";

import { ContentfulClientProvider } from "@expert/contentful";
import { Notifications } from "@mantine/notifications";
import { RouterProvider } from "react-router";
import "@mantine/notifications/styles.css";
import { GlobalThemeProvider } from "@expert/theme";
import { FeedbackContextProvider } from "@soluto-private/expert-workspace-feedback";
import { createClient } from "contentful";
import { AuthenticationProvider } from "./auth";
import { ReactQueryClient } from "./providers";
import { RoutePath, router } from "./routes";
import { env } from "./utils/env";

const contentfulClient = createClient(env.contentful);

export function App() {
    return (
        <GlobalThemeProvider>
            <AuthenticationProvider redirectPath={RoutePath.Home}>
                <ContentfulClientProvider client={contentfulClient}>
                    <ReactQueryClient>
                        <Notifications
                            limit={1}
                            position="top-center"
                            zIndex="var(--mantine-priority-highest)"
                            data-testid="notifications-center"
                        />
                        <FeedbackContextProvider expertFeedbackUrl={env.expertFeedbackUrl}>
                            <RouterProvider router={router} />
                        </FeedbackContextProvider>
                    </ReactQueryClient>
                </ContentfulClientProvider>
            </AuthenticationProvider>
        </GlobalThemeProvider>
    );
}
